/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * ViewModel-layer surface for localized strings.
 *
 * `Locale` / `LocaleKeys` live in the model layer, but views must not reach
 * into `src/model/**` directly (MVVM: model → viewModel → views, enforced by
 * scripts/lint-mvvm.cjs). This barrel is the sanctioned path — same shape as
 * viewModel/logging and viewModel/navigation.
 */
export { Locale, LocaleKeys } from "../../model/locale";

export default {};
